import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { BaseDataReportDirectory } from 'src/app/interfaces/base-data-report-directory';
import { BaseDataReportFile } from 'src/app/interfaces/base-data-report-file';
import { BasedatareportService } from 'src/app/services/basedatareport.service';
import { OverlayService } from 'src/app/services/overlay.service';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-base-data-report',
  templateUrl: './base-data-report.component.html',
  styleUrls: ['./base-data-report.component.scss']
})
export class BaseDataReportComponent implements OnInit {
  finishedLoading: boolean = false;
  dataSource: MatTableDataSource<any>;
  displayedColumns = ['number', 'type', 'name', 'size', 'lastModified', 'menu'];
  page = null;
  pageData = {
    pageIndex: 0,
    pageSize: 12
  }

  constructor(
    private overlayService: OverlayService,
    private basedatareportService: BasedatareportService
  ) { }

  ngOnInit(): void {
    this.basedatareportService.getReports().subscribe((reports: BaseDataReportDirectory) => {
      this.dataSource = new MatTableDataSource(reports.files)
      this.finishedLoading = true;
    })
  }

  downloadReport(report) {
    this.basedatareportService.downloadReport(report).subscribe((reportFile) => {
      const contentType = 'application/octet-stream';
      const blob = new Blob([reportFile], { type: contentType });
      const objectUrl: string = URL.createObjectURL(blob);
      const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
      a.href = objectUrl;
      a.download = report;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl)
    })
  }
  sortData(sort: Sort) {
    this.dataSource.data = this.dataSource.data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'lastModified':
          return compare(a.lastModified, b.lastModified, isAsc);
        case 'size':
          return compare(a.size, b.size, isAsc);
        case 'name':
          return compare(a.name, b.name, isAsc);
        case 'processType':
          return compare(a.processType, b.processType, isAsc);
        case 'type':
          return compare(a.type, b.type, isAsc);
        default:
          return 0;
      }
    });
  }
/**
 * 
 */
  startReport(){
    this.basedatareportService.startReport().subscribe(() => {
        this.overlayService.openSnackBar("Report erfolgreich gestartet");
        this.basedatareportService.getReports().subscribe((reports: BaseDataReportDirectory) => {
          this.dataSource = new MatTableDataSource(reports.files)
          this.finishedLoading = true;
        })
    })
  }
}

/**
 * Compare Two values
 * @param a 
 * @param b 
 * @param isAsc 
 * @returns 
 */
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
